export var KEY_PREFIX = 'reduxPersist:';
export var REHYDRATE = 'persist/REHYDRATE';


//////////////////
// WEBPACK FOOTER
// ../~/redux-persist/es/constants.js
// module id = 66
// module chunks = 7